<template>
    <div class="row mx-0 col-12 px-0 mt-4">
        <h3 class="theme-primary col-12 px-0">{{title}}</h3>
    <div role="presentation">
        <DataHeader :column-data="columnData" :get-header-id="() => getConsentElementId('','dataheader')">
            <div class="d-flex col-12 col-md-6 px-0">
                <div class="d-flex col-md-12 col-md-6 px-0" role="radiogroup" :aria-labelledby="getConsentElementId('','dataheader')">
                    <div class="col-6 px-0">
                        <input id="allTypeYes" type="radio" name="allType" class="m-0" value="Y" v-model="allType" />
                        <label for="allTypeYes" class="all form-check-label pl-1 theme-primary font-weight-bold">{{allEmail}}</label>
                    </div>
                    <div class="col-6 px-0">
                        <input id="allTypeNo" type="radio" name="allType" class="m-0" value="N" v-model="allType" />
                        <label for="allTypeNo" class="all form-check-label pl-1 theme-primary font-weight-bold">{{allMail}}</label>
                    </div>
                </div>
            </div>
        </DataHeader>
        <div class="row col-12 px-0 mx-0">
        <DataRow v-for="(option, index) in options" class-markers="row col-12 px-0 mx-0 account" :get-id="() => getConsentElementId(index, 'method')" :column-data="columnData" :row-data="getRowData(option)">    
            <div class="d-flex col-12 col-md-6 px-0">        
                <div class="d-flex col-md-12 col-md-6 px-0 pt-2 pt-md-0" role="radiogroup" :aria-labelledby="getConsentElementId(index, 'method')">
                    <div class="col-6 px-0">
                        <input :id="getId(option.consentCustStmtTypeId,'Yes')" type="radio" :name="getId(option.consentCustStmtTypeId,'Document')" class="m-0" value="Y" v-model="option.electronicDeliveryCode" />
                        <label :for="getId(option.consentCustStmtTypeId,'Yes')" class="form-check-label pl-1">{{email}}</label>
                    </div>
                    <div class="col-6 px-0">
                        <input :id="getId(option.consentCustStmtTypeId,'No')" type="radio" :name="getId(option.consentCustStmtTypeId,'Document')" class="m-0" value="N" v-model="option.electronicDeliveryCode" />
                        <label :for="getId(option.consentCustStmtTypeId,'No')" class="form-check-label pl-1">{{mail}}</label>
                    </div>
                </div>
            </div>
        </DataRow>
        </div>
    </div>
    </div>
</template>

<script>
    import DataHeader from './DataHeader.vue';
    import DataRow from './DataRow.vue';
    let instanceCount = 0;

    export default {
        name: "ConsentOptions",

        emits: ['update-consent'],

        components: {
            DataHeader,
            DataRow
        },

        props: {
            title: String,
            allEmail: String,
            email: String,
            allMail: String,
            mail: String,
            columnData: Object,
            options: Array
        },

        data: function() {
            return {
                allType: "",
                instanceId: `choose-delivery-${instanceCount++}`
            }
        },

        methods: {
           getConsentElementId: function (index = '', type) {
                return `${this.instanceId}-${type}${index !== '' ? `-${index}` : ''}`;
            },
            init: function() {
                var allMail = true;
                var allEmail = true;

                this.options.forEach(function(option) {
                    if (option.electronicDeliveryCode === "Y") {
                        allMail = false;
                    }
                    else {
                        allEmail = false;
                    }
                });

                if (allEmail) {
                    this.allType = "Y";
                }
                else if(allMail) {
                    this.allType = "N";
                }
                else {
                    this.allType = "";
                }
            },

            getRowData: function(option) {
                return [
                    {
                        columnValue: option.consentStatementTypeNm
                    }
                ];
            },

            getId: function(name, type) {
                return name + type;
            }
        },

        watch: {
            options: {
                deep: true,
                handler: function(val) {
                    var allMail = true;
                    var allEmail = true;

                    val.forEach(function(option) {
                        if (option.electronicDeliveryCode === "Y") {
                            allMail = false;
                        }
                        else {
                            allEmail = false;
                        }
                    });

                    if (allEmail) {
                        this.allType = "Y";
                    }
                    else if(allMail) {
                        this.allType = "N";
                    }
                    else {
                        this.allType = "";
                    }

                    this.$emit('update-consent', val);
                }
            },

            allType: function(val) {
                if (val !== "") {
                    this.options.forEach(function(option) {
                       option.electronicDeliveryCode = val; 
                    });
                }
            }
        }
    }
</script>

<style scoped>
    label.all {
        font-size: 1.25rem;
    }
</style>